import React, { useState } from 'react';
import FileItem from './FileItem';
import '../../styling/FileList.css';

function FileList({ files = [], removeFile, isUploading, folderName }) {

    return (
        <div className="file-list">
            {files && files.map(file => (
                <FileItem
                    key={file.name}
                    file={file}
                    deleteFile={() => removeFile(file, file.type)} // Pass file name to delete handler
                    isUploading={isUploading}
                />
            ))}
        </div>
    );
}

export default FileList;